import * as React from "react";
function SvgPortraitFrame(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21 4a1 1 0 00-1-1h-5v2h4v4h2V4zM4 3a1 1 0 00-1 1v5h2V5h4V3H4zm17 18a1 1 0 01-1 1h-5v-2h4v-4h2v5zM3 21a1 1 0 001 1h5v-2H5v-4H3v5zm6.684-4.145C9.15 17.355 9 17.859 9 18H7c0-.859.517-1.855 1.316-2.605C9.158 14.605 10.4 14 12 14c1.6 0 2.842.606 3.684 1.395C16.483 16.145 17 17.141 17 18h-2c0-.141-.15-.645-.684-1.145-.491-.46-1.25-.855-2.316-.855-1.066 0-1.825.394-2.316.855zM13 10a1 1 0 11-2 0 1 1 0 012 0zm2 0a3 3 0 11-6 0 3 3 0 016 0z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgPortraitFrame);
export default ForwardRef;
